import { useState } from 'react';

// FAQ data - customize questions and answers here
const faqData = [
  {
    id: 1,
    question: "Што е Futurathon 2025?",
    answer: "Futurathon 2025 е иновативен хакатон што се фокусира на градење на иднината преку технологија, креативност, како и тимска работа. Придружете ни се на возбудлива авантура полна со дружење и иновативност!"
  },
  {
    id: 2,
    question: "Кога и каде ќе се оддржи?",
    answer: "Настанот ќе се одржува во Скопје, во просториите на ITLabs, почнувајќи од 20ти и завршувајќи на 21ви декември."
  },
  {
    id: 3,
    question: "Кој може да учествува?",
    answer: "Само студенти во Македонија. Програмери, дизајнери, претприемници, како и кој било заинтересиран за технологија и иновација е добредојден! И почетници и искусни натпреварувачи се охрабруваат да се пријават."
  },
  {
    id: 4,
    question: "Дали има котизација за учество?",
    answer: "Не! Futurathon 2025 е целосно бесплатен за присуствување. Веруваме дека иновацијата треба да е пристапна за сите што сакаат да присуствуваат."
  },
  {
    id: 5,
    question: "Што треба да донесам?",
    answer: "Лаптоп, полнач, ентузијазам, како и кретаивност! Ние обезбедуваме храна, менторство, место за работа, како и неверојатна околина за градење на вашите идеи."
  },
  {
    id: 6,
    question: "Дали има награди?",
    answer: "Да! Имаме награда за победничкиот тим. Подетални информации за наградите ќе бидат објавени пред почетокот на настанот."
  }
];

function FAQ() {
  const [openId, setOpenId] = useState(null);

  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div
      className="min-h-screen w-full overflow-x-hidden py-16 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: '#E4570B' }}
    >
      {/* Title Section */}
      <div className="max-w-4xl mx-auto mb-16 text-center">
        <h1 
          className="font-zeitmax font-bold text-6xl sm:text-7xl md:text-8xl lg:text-9xl mb-6"
          style={{ 
            color: '#DFC293',
            textShadow: '0 0 30px rgba(223, 194, 147, 0.5), 0 0 60px rgba(239, 167, 79, 0.3)',
            letterSpacing: '0.05em'
          }}
        >
          FAQ
        </h1>
        <div 
          className="h-1.5 w-40 mx-auto rounded-full"
          style={{ 
            background: 'linear-gradient(90deg, #EFA74F 0%, #DFC293 50%, #749269 100%)',
            boxShadow: '0 0 20px rgba(239, 167, 79, 0.6)',
            pointerEvents: 'none'
          }}
        />
      </div>

      {/* FAQ Accordion Cards */}
      <div className="max-w-4xl mx-auto space-y-5">
        {faqData.map((item) => {
          const isOpen = openId === item.id;
          return (
            <div
              key={item.id}
              className="rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer"
              style={{
                backgroundColor: '#6A310A',
                border: '2px solid',
                borderColor: isOpen ? '#EFA74F' : '#749269',
                boxShadow: isOpen 
                  ? '0 10px 40px rgba(239, 167, 79, 0.5), 0 0 30px rgba(239, 167, 79, 0.3), inset 0 1px 0 rgba(255,255,255,0.1)'
                  : '0 4px 20px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255,255,255,0.05)',
                willChange: 'transform',
              }}
              onClick={() => toggleAccordion(item.id)}
            >
              {/* Question Header */}
              <div
                className="px-6 py-6 sm:px-8 sm:py-7 flex justify-between items-center gap-4"
                style={{
                  background: isOpen 
                    ? 'linear-gradient(135deg, rgba(116, 146, 105, 0.25) 0%, rgba(239, 167, 79, 0.15) 100%)'
                    : 'transparent',
                  transition: 'background 0.4s ease'
                }}
              >
                <h3 
                  className="text-2xl sm:text-3xl md:text-4xl transition-all duration-300"
                  style={{ 
                    color: isOpen ? '#EFA74F' : '#DFC293',
                    textShadow: isOpen ? '0 0 15px rgba(239, 167, 79, 0.4)' : 'none',
                    fontFamily: 'Sagewold, serif',
                    fontWeight: 400
                  }}
                >
                  {item.question}
                </h3>
                <div
                  className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center transition-all duration-400"
                  style={{
                    backgroundColor: isOpen ? '#EFA74F' : '#749269',
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    boxShadow: isOpen 
                      ? '0 0 20px rgba(239, 167, 79, 0.6), 0 4px 12px rgba(0,0,0,0.3)' 
                      : '0 2px 8px rgba(0,0,0,0.2)'
                  }}
                >
                  <svg
                    className="w-6 h-6 sm:w-7 sm:h-7"
                    fill="none"
                    stroke="#6A310A"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>

              {/* Answer Section - Smooth expand animation from bottom */}
              <div
                className="overflow-hidden transition-all duration-500 ease-in-out"
                style={{
                  maxHeight: isOpen ? '600px' : '0px',
                  opacity: isOpen ? 1 : 0,
                }}
              >
                <div
                  className="px-6 py-6 sm:px-8 sm:py-7 text-xl sm:text-2xl leading-relaxed"
                  style={{
                    color: '#DFC293',
                    backgroundColor: 'rgba(116, 146, 105, 0.2)',
                    borderTop: '1px solid rgba(239, 167, 79, 0.4)',
                    fontFamily: 'Sagewold, serif'
                  }}
                >
                  {item.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Bottom Section */}
      <div className="max-w-4xl mx-auto mt-20 text-center">
        <p 
          className="text-2xl sm:text-3xl mb-4"
          style={{ 
            color: '#DFC293',
            textShadow: '0 0 10px rgba(223, 194, 147, 0.3)',
            fontFamily: 'Sagewold, serif'
          }}
        >
          Сè уште имате прашања?
        </p>
        <p 
          className="text-xl sm:text-2xl mb-6"
          style={{ color: '#DFC293', opacity: 0.85, fontFamily: 'Sagewold, serif' }}
        >
          Слободно контактирајте нè - тука сме да помогнеме!
        </p>
        <div 
          className="h-1 w-32 mx-auto rounded-full"
          style={{ 
            background: 'linear-gradient(90deg, #749269 0%, #EFA74F 100%)',
            boxShadow: '0 0 15px rgba(116, 146, 105, 0.5)',
            pointerEvents: 'none'
          }}
        />
      </div>

    </div>
  );
}

export default FAQ;
